import React from "react";
import {
  SIGNAL_BARS,
  signalBars,
  signalLabel,
  signalLevel,
} from "../../helpers/signal";
import styles from "./SignalBars.module.scss";

/*
 * Signal as four rising bars instead of a percentage, matching the battery's
 * bars beside it. A device with no reading shows nothing, as before.
 */
export default function SignalBars({ signal, compact = false }) {
  if (!signal) return null;

  const bars = signalBars(signal);
  const label = signalLabel(bars);
  return (
    <div
      className={[
        styles.wrap,
        styles[signalLevel(bars)],
        compact ? styles.compact : "",
      ].join(" ")}
      title={label}
      role="img"
      aria-label={label}
    >
      <div className={styles.signal}>
        {Array.from({ length: SIGNAL_BARS }, (_, i) => (
          <span key={i} className={i < bars ? styles.lit : styles.segment} />
        ))}
      </div>
    </div>
  );
}
